/**
****************************************************************************************
Project: Readabl
File: ZoomComponent.js
Description: This component will render and handles zoom functionality of the pdf viewer.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React, { useEffect, useState } from "react";
import { Remove, Add } from "@mui/icons-material";
import { IconButton } from "@mui/material";

const ZOOM_LEVELS = [
    0.25,
    0.33,
    0.5,
    0.67,
    0.75,
    0.9,
    1,
    1.1,
    1.25,
    1.5,
    1.75,
    2,
    2.5,
    3
];

function getInitialZoom(container, viewport) {
    const fitScale = Math.min(
        container.width / viewport.width,
        container.height / viewport.height
    );

    const validZooms = ZOOM_LEVELS.filter(
        (zoom) => zoom <= fitScale
    );



    const temp = validZooms.length
        ? Math.max(...validZooms)
        : ZOOM_LEVELS[6];
    return temp >= 1 ? 6 : ZOOM_LEVELS.indexOf(temp);
}
const ZoomComponent = (props) => {

    const [zoomIndex, updateZoomIndex] = useState(6);

    useEffect(() => {
        const initialZoomIndex = getInitialZoom(props.imageDimensions, props.viewport);
        if (initialZoomIndex > 0) {
            updateZoomIndex(initialZoomIndex);
            props.handleZoom(ZOOM_LEVELS[initialZoomIndex]);
        }

    }, [])

    // this function handles both + / - button click event
    const handleZoom = (action) => {
        let currentIndex = zoomIndex;
        if (action == "out" && zoomIndex > 0) currentIndex -= 1;
        if (action == "in" && zoomIndex < ZOOM_LEVELS?.length - 1) currentIndex += 1;
        updateZoomIndex(currentIndex);
        props.handleZoom(ZOOM_LEVELS[currentIndex]);
    }
    return (
        <div className="pdf-viewer-zoom-container" style={{ pointerEvents: props.disabled ? "none" : "auto", cursor: props.disabled ? "not-allowed" : "auto" }}>
            <IconButton onClick={() => (zoomIndex <= ZOOM_LEVELS?.length - 1 && zoomIndex > 0) && handleZoom("out")}>
                <Remove sx={{ color: "#FFF" }} />
            </IconButton>
            <div className="pdf-viewer-zoom-val">{(props.zoomLevel * 100).toFixed(0)}%</div>
            <IconButton onClick={() => (zoomIndex >= 0 && zoomIndex < ZOOM_LEVELS?.length - 1) && handleZoom("in")}>
                <Add sx={{ color: "#FFF" }} />
            </IconButton>
        </div>
    )
}

export default ZoomComponent;